module.exports = __webpack_public_path__ + "static/media/sorrento.396ea789.jpg";